import React, { memo, useCallback, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCopy, faEdit, faFile,
} from '@fortawesome/free-regular-svg-icons';
import {
  faCheck, faTimes, faTrash,
} from '@fortawesome/free-solid-svg-icons';
import {
  ListItemIcon, ListItemText, Menu, MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';
import ListerContext from '../../context';

function DocCtxMenu({ children }) {
  const {
    ctxMenu,
    onHideCtxMenu,
    actions,
    permissions,
  } = useContext(ListerContext);
  const onEdit = useCallback(
    (e) => {
      onHideCtxMenu(e);
      actions.onEdit(e);
    },
    [actions, onHideCtxMenu],
  );
  const onCopy = useCallback(
    (e) => {
      onHideCtxMenu(e);
      actions.onCopy(e);
    },
    [actions, onHideCtxMenu],
  );
  const onDelete = useCallback(
    (e) => {
      onHideCtxMenu(e);
      actions.onDelete(e);
    },
    [actions, onHideCtxMenu],
  );
  const onExecute = useCallback(
    (e) => {
      onHideCtxMenu(e);
      actions.onExecute(e);
    },
    [actions, onHideCtxMenu],
  );
  const onUnexecute = useCallback(
    (e) => {
      onHideCtxMenu(e);
      actions.onUnexecute(e);
    },
    [actions, onHideCtxMenu],
  );
  return (
    <Menu
      open={ctxMenu.visible}
      onClose={onHideCtxMenu}
      anchorReference="anchorPosition"
      anchorPosition={{
        top: ctxMenu.top,
        left: ctxMenu.left,
      }}
    >
      <MenuItem onClick={onEdit} disabled={!permissions.canEdit}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faEdit} className="mr-2" />
        </ListItemIcon>
        <ListItemText>
          Змінити
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={onCopy} disabled={!permissions.canCopy}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faCopy} className="mr-2" />
        </ListItemIcon>
        <ListItemText>
          Копіювати
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={onDelete} disabled={!permissions.canDelete} divider sx={{ color: 'red' }}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faTrash} className="mr-2" />
        </ListItemIcon>
        <ListItemText>
          Видалити
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={onExecute} disabled={!permissions.canExecute}>
        <ListItemIcon>
          <span className="fa-layers fa-fw mr-2">
            <FontAwesomeIcon icon={faFile} size="lg" />
            <FontAwesomeIcon icon={faCheck} color="var(--success)" transform="shrink-6 down-2" />
          </span>
        </ListItemIcon>
        <ListItemText>
          Провести
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={onUnexecute} disabled={!permissions.canUnexecute}>
        <ListItemIcon>
          <span className="fa-layers fa-fw mr-2">
            <FontAwesomeIcon icon={faFile} size="lg" />
            <FontAwesomeIcon icon={faTimes} color="var(--danger)" transform="shrink-6 down-2 left-1" />
          </span>
        </ListItemIcon>
        <ListItemText>
          Відмінити проведення
        </ListItemText>
      </MenuItem>
      {children}
    </Menu>
  );
}

DocCtxMenu.propTypes = {
  children: PropTypes.node,
};

DocCtxMenu.defaultProps = {
  children: null,
};

export default memo(DocCtxMenu);
